/* eslint-disable no-undef */
import "./index.scss"
import {useEffect, useRef, useState} from "react";
import { Button, Input, Space } from 'antd';
import dayjs from "dayjs";
import request from "../../api/request";
import {BASE_URL} from "../../api/config";

// 警報訊息中文化核心解析器
const translateAlarmMessage = (msg) => {
    if (!msg) return "";

    if (msg.includes("pH Type=")) return "pH值過高";
    if (msg.includes("ORP Type=")) return "氧化還原電位(ORP)異常";
    if (msg.includes("EC Type=") || msg.includes("Type=220")) return "導電度過高";
    
    if (msg.includes("Communication error")) return "設備通訊中斷";
    if (msg.includes("Battery Low")) return "設備電量過低";
    if (msg.includes("超出警報值")) return "AI影像監測異常";

    return msg;
};

// 每天上午 6:00 更新一次 90.0～110.0 的模擬 COD 數值。
// 當日上午 6:00 至隔日上午 5:59，重新整理頁面仍會保持相同數值。
const getDailyCodAverage = () => {
    const sixHours = 6 * 60 * 60 * 1000;
    const oneDay = 24 * 60 * 60 * 1000;

    // 將每日分界點由午夜 00:00 平移至上午 06:00
    const dailySlot = Math.floor((Date.now() - sixHours) / oneDay);
    const pseudoRandom =
        Math.abs(Math.sin(dailySlot * 12.9898) * 43758.5453) % 1;

    return 90 + pseudoRandom * 20;
};

const Dashboard = () => {
    const [ip,setIp] = useState("127.0.0.1");
    const [time,setTime]  = useState("");
    const [time2,setTime2] = useState("");
    const [rain, setRain] = useState("");
    const [cameraStatus, setCameraStatus] = useState({
        camera1: true,
        camera2: true,
        camera3: true
    });

    useEffect(()=>{
        if(ip){
            const currentHost = window.location.hostname;
            let baseSource = `wss://${currentHost}/ws/rtsp?url=`;
            var rtsp1 = 'rtsp://admin:27329077@220.130.68.60:554/ip03/1';
            var rtsp2 = 'rtsp://admin:27329077@220.130.68.60:554/ip02/1';
            var rtsp3 = 'rtsp://admin:27329077@220.130.68.60:554/ip01/1';

            const reconnectCamera = (index, url, canvasId) => {
                console.log(`嘗試重新連接攝影機 ${index}`);
                const canvas = document.getElementById(canvasId);
                if (canvas) {
                    const existingPlayer = canvas._jsmpeg;
                    if (existingPlayer) {
                        existingPlayer.destroy();
                    }
                }
                return createPlayer(url, canvasId, index);
            };

            const createPlayer = (url, canvasId, index) => {
                const player = new JSMpeg.Player(baseSource + btoa(url), {
                    canvas: document.getElementById(canvasId),
                    audio: false,
                    throttled: true,
                    maxDecodingTime: 2,
                    reconnectInterval: 3000,
                    timeout: 5000,

                    onSourceEstablished: () => {
                        console.log(`攝影機 ${index} 視訊源建立完成`);
                        setCameraStatus(prev => ({
                            ...prev,
                            [`camera${index}`]: true
                        }));
                    },
                    
                    onError: (error) => {
                        console.error(`攝影機 ${index} 發生錯誤:`, error);
                        setCameraStatus(prev => ({
                            ...prev,
                            [`camera${index}`]: false
                        }));
                        setTimeout(() => reconnectCamera(index, url, canvasId), 5000);
                    }
                });

                return player;
            };

            const playerInstances = [
                createPlayer(rtsp1, 'canvas-1', 1),
                createPlayer(rtsp2, 'canvas-2', 2),
                createPlayer(rtsp3, 'canvas-3', 3)
            ];

            return () => {
                playerInstances.forEach(player => {
                    if (player && typeof player.destroy === 'function') {
                        player.destroy();
                    }
                });
            };
        }
    },[ip])

    useEffect(()=>{
        const timerID = setInterval(() => {
            fetchTime();
        }, 1000);
        return () => clearInterval(timerID);
    },[])

    const fetchTime = ()=>{
        setTimes();
    }

    useEffect(()=>{
        fetchDatas();
        const timerDataID = setInterval(() => {
            fetchDatas();
        }, 1000 * 5 * 60);
        return () => clearInterval(timerDataID);
    },[])

    useEffect(()=>{
        setRainFallData();
        const timerRainDataID = setInterval(() => {
            setRainFallData();
        }, 1000 * 60 * 6 * 60);
        return () => clearInterval(timerRainDataID);
    },[])

    useEffect(()=>{
        fetchWarn();
        const timerDataID = setInterval(() => {
            fetchWarn();
        }, 1000);
        return () => clearInterval(timerDataID);
    },[])

    const fetchDatas = ()=>{
        setDashboardData();
    }
    const fetchWarn = ()=>{
        setAlarmData();
    }

    const inputRef = useRef();
    const handleIpChange = ()=>{
        setIp(inputRef.current.input.value)
    }
    const setRainFallData = ()=>{
        fetch('https://opendata.cwa.gov.tw/api/v1/rest/datastore/O-A0002-001?Authorization=CWA-8958B22C-43A3-482F-B46B-89F3019D0F87&limit=50&format=JSON&StationId=467420')
            .then(res => res.json())
            .then(res => {
                const data = res.records.Station[0];
                setTime2(dayjs(data.ObsTime.DateTime).format('YYYY-MM-DD HH:mm'))
                setRain(data.RainfallElement.Now.Precipitation)
            })
    }
    const [alarmTotal, setAlarmTotal] = useState(0)
    const [alarmList,setAlarmList] = useState([]);
    const [ph,setPh] = useState("0");
    const [ll,setLl] = useState("0");
    const [orp,setOrp] = useState("0");
    const [ss,setSs] = useState("0");
    const [sd,setSd] = useState("0");
    const [cod,setCod] = useState("0");
    const [ddd,setDdd] = useState("0");
    const [pall,setPall] = useState("0");
    const [pbll,setPbll] = useState("0");
    const [paddd,setPaddd] = useState("0");
    const [pbddd,setPbddd] = useState("0");
    const [cnll,setCnll] = useState("0");

    const codAverage24h = getDailyCodAverage();

    const predictedConductivity = (
        Number(ddd) * 0.6 +
        Number(paddd) * 0.2 +
        Number(pbddd) * 0.2
    ) * 1000;

    const setDashboardData = ()=>{
        GetAPPRTULogData();
    }
    const setAlarmData = ()=>{
        GetAlarmData();
    }

    const GetAlarmData = () => {
        request.post(BASE_URL + '/water/get_alarm_data', {
            page_num: 0,
            page_size: 10,
            status: "0",
            log_id: "",
            time_sort: 1,
            startRage: "",
            endRage: ""
        }).then(res => {
            setAlarmList([])
            setAlarmTotal(0)
            
            if(res.code !== 200 || !res.data){
                console.warn('警報資料回應異常:', res);
                return;
            }

            const rows = Array.isArray(res.data.rows) ? res.data.rows : [];
            
            setAlarmList(rows)
            setAlarmTotal(res.data.total || 0)
        }).catch(err => {
            console.error('獲取警報資料失敗:', err);
            setAlarmList([])
            setAlarmTotal(0)
        })
    }

    const GetAPPRTULogData = (data,type) => {
        request.post(  BASE_URL + '/water/get_panel_data', data).then(res => {
            if(res.code != 200 || !res.data){
                return;
            }
            if(res.data.pa_data && res.data.pa_data.length){
                res.data.pa_data.forEach(item=>{
                    if(item.sensor_id === "12"){
                        setPall((+item.value).toFixed(1))
                    }else if(item.sensor_id === "50"){
                        setPaddd((+item.value).toFixed(1))
                    }
                })
            }
            if(res.data.pb_data && res.data.pb_data.length){
                res.data.pb_data.forEach(item=>{
                    if(item.sensor_id === "12"){
                        setPbll((+item.value).toFixed(1))
                    }else if(item.sensor_id === "50"){
                        setPbddd((+item.value).toFixed(1))
                    }
                })
            }

            if(res.data.point_data && res.data.point_data.length){
                res.data.point_data.forEach(item=>{
                    if(item.sensor_id === "50"){
                        setCnll((+item.value).toFixed(1))
                    }
                })
            }

            if(res.data.station_data && res.data.station_data.length){
                res.data.station_data.forEach(item=>{
                    if(item.sensor_id === "12"){
                        setLl((+item.value).toFixed(1))
                    }else if(item.sensor_id === "52"){
                        setDdd((+item.value).toFixed(1))
                    }else if(item.sensor_id === "62"){
                        setCod((+item.value).toFixed(1))
                    }else if(item.sensor_id === "53"){
                        setSd((+item.value).toFixed(1))
                    }else if(item.sensor_id === "54"){
                        setSs((+item.value).toFixed(1))
                    }else if(item.sensor_id === "50"){
                        setPh((+item.value).toFixed(1))
                    }else if(item.sensor_id === "51"){
                        setOrp((+item.value).toFixed(1))
                    }
                })
            }
        }).catch(err=>{
            console.log('err',err)
        })
    }

    const setTimes = ()=>{
        setTime(dayjs().format('YYYY-MM-DD HH:mm:ss'))
    }

    const clearAlarm = async (id) => {
        const item = document.querySelector(`.warning-item[data-id="${id}"]`);
        if (!item) return;

        item.classList.add('removing');

        const handleTransitionEnd = () => {
            item.removeEventListener('transitionend', handleTransitionEnd);
            setAlarmTotal(prev => prev - 1);
            setAlarmList(prev => prev.filter(alarm => alarm.id !== id));
        };

        item.addEventListener('transitionend', handleTransitionEnd);

        try {
            await request.post(BASE_URL + '/water/alarm/delete', {id});
            fetchWarn();
        } catch (error) {
            console.error('Failed to delete alarm:', error);
            item.classList.remove('removing');
            item.removeEventListener('transitionend', handleTransitionEnd);
        }
    };

    return (
        <div className="index">
            <div className="header">
                <div className="site-name">5G 智慧水情資訊雲平台</div>
                <div className="now-time">{time}</div>
            </div>

            <div className="box">
                {/* 左側欄 */}
                <div className="box-item">
                    <div className="data-box" style={{marginBottom:'2.5vh', height:'18vh'}}>
                        <div className="hd">永康雨量測站資料</div>
                        <div className="bd">
                            <div
                                className="rain"
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    width: '100%',
                                    height: '100%',
                                    gap: '8px'
                                }}
                            >
                                <div className="time">{time2}</div>
                                <div
                                    style={{
                                        color: '#ffffff',
                                        fontSize: '1.8vh',
                                        fontWeight: 'bold',
                                        textAlign: 'center'
                                    }}
                                >
                                    雨量：{rain || '--'} mm
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="data-box" style={{height:'62vh'}}>
                        <div className="hd">柴頭港溪截流站</div>
                        <div className="bd">
                            <div className="data-line">
                                <div className="left">
                                    <div className="icon">
                                        <img className="icon-img" src="/assets/liuliang.png" />
                                        <img className="round" src="/assets/round.png"/>
                                    </div>
                                    <div className="title">流量</div>
                                    <div className="value">{(ll)}</div>
                                </div>
                                <div className="unit">(CMH)</div>
                            </div>
                            <div className="data-line">
                                <div className="left">
                                    <div className="icon">
                                        <img className="icon-img" src="/assets/daodiandu.png"/>
                                        <img className="round" src="/assets/round.png"/>
                                    </div>
                                    <div className="title">導電度</div>
                                    <div className="value">{ddd ? (Number(ddd) * 1000).toFixed(1) : 0}</div>
                                </div>
                                <div className="unit">(uS/cm)</div>  
                            </div>
                            <div className="data-line">
                                <div className="left">
                                    <div className="icon">
                                        <img className="icon-img" src="/assets/cod.png"/>
                                        <img className="round" src="/assets/round.png"/>
                                    </div>
                                    <div className="title">COD</div>
                                    <div className="value">{cod}</div>
                                </div>
                                <div className="unit">(mg/L)</div>
                            </div>
                            <div className="data-line">
                                <div className="left">
                                    <div className="icon">
                                        <img className="icon-img" src="/assets/zhuodu.png"/>
                                        <img className="round" src="/assets/round.png"/>
                                    </div>
                                    <div className="title">濁度</div>
                                    <div className="value">{sd}</div>
                                </div>
                                <div className="unit">(NTU)</div>
                            </div>
                            <div className="data-row">
                                <div className="data-col">
                                    <div className="title">SS</div>
                                    <div className="unit">(mg/L)</div>
                                    <div className="value">{ss}</div>
                                </div>
                                <div className="data-col">
                                    <div className="title">pH</div>
                                    <div className="unit"></div>
                                    <div className="value">{ph}</div>
                                </div>
                                <div className="data-col">
                                    <div className="title">ORP</div>
                                    <div className="unit">(mV)</div>
                                    <div className="value">{orp}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* 中間欄 */}
                <div className="box-item2">
                    <div className="video-row">
                        <div className="video-item">
                            <div className="video-container">
                                <canvas 
                                    id="canvas-1" 
                                    className={!cameraStatus.camera1 ? 'offline' : ''}
                                ></canvas>
                                {!cameraStatus.camera1 && (
                                    <div className="video-offline">
                                        <div className="offline-text">監視器訊號中斷，正在嘗試重新連接...</div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="video-item">
                            <div className="video-container">
                                <canvas 
                                    id="canvas-2" 
                                    className={!cameraStatus.camera2 ? 'offline' : ''}
                                ></canvas>
                                {!cameraStatus.camera2 && (
                                    <div className="video-offline">
                                        <div className="offline-text">監視器訊號中斷，正在嘗試重新連接...</div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="video-item">
                            <div className="video-container">
                                <canvas 
                                    id="canvas-3" 
                                    className={!cameraStatus.camera3 ? 'offline' : ''}
                                ></canvas>
                                {!cameraStatus.camera3 && (
                                    <div className="video-offline">
                                        <div className="offline-text">監視器訊號中斷，正在嘗試重新連接...</div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="center-row">
                        {/* PA管網 */}
                        <div className="center-item">
                            <div className="hd">
                                <img className="title-icon" src="/assets/title-icon.png"/>
                                <div className="title">PA管網</div>
                            </div>
                            <div className="bd">
                                <div className="bd-item">
                                    <div className="title">流量</div>
                                    <div className="unit">(CMH)</div>
                                    <div className="value">{pall}</div>
                                </div>
                                <div className="bd-item">
                                    <div className="title">導電度</div>
                                    <div className="unit">(uS/cm)</div>
                                    <div className="value">{paddd ? (paddd * 1000).toFixed(1) : 0}</div>   
                                </div>
                            </div>
                        </div>

                        {/* PB管網 */}
                        <div className="center-item">
                            <div className="hd">
                                <img className="title-icon" src="/assets/title-icon.png"/>
                                <div className="title">PB管網</div>
                            </div>
                            <div className="bd">
                                <div className="bd-item">
                                    <div className="title">流量</div>
                                    <div className="unit">(CMH)</div>
                                    <div className="value">{pbll}</div>
                                </div>
                                <div className="bd-item">
                                    <div className="title">導電度</div>
                                    <div className="unit">(uS/cm)</div>
                                    <div className="value">{pbddd ? (pbddd * 1000).toFixed(1) : 0}</div>
                                </div>
                            </div>
                        </div>

                        {/* 廠內進流點 */}
                        <div className="center-item center-item-single">
                            <div className="hd">
                                <img className="title-icon" src="/assets/title-icon.png"/>
                                <div className="title">廠內進流點</div>
                            </div>
                            <div className="bd">
                                <div className="bd-item single-item">
                                    <div className="title">油脂含量</div>
                                    <div className="unit">(µg/L)</div>
                                    <div className="value">{cnll}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* 右側欄 */}
                <div className="box-item">
                    {/* 右上角：水質告警門檻 (閾值) */}
                    <div className="data-box" style={{height:'24vh', marginBottom:'2.5vh'}}>
                        <div className="hd">水質告警門檻 (閾值)</div>
                        <div className="bd" style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            textAlign: 'center',
                            fontSize: '1.8vh',
                            fontWeight: 'bold',
                            lineHeight: '1.6'
                        }}>
                            <div>導電度 1200 (µs/cm)</div>
                            <div>pH 8</div>
                            <div>濁度 250 (NTU)</div>
                            <div>SS 100 (mg/L)</div>
                            <div>COD 100 (mg/L)</div>
                        </div>
                    </div>

                    {/* 右下角：① 廠外水質警報 + ② 廠外進流水質預測 */}
                    <div className="data-box right-bottom-box" style={{
                        height: '62vh', 
                        display: 'flex', 
                        flexDirection: 'column', 
                        padding: '12px 15px'
                    }}>
                        {/* ① 廠外水質警報 (即時) */}
                        <div className="sub-section section-1">
                            <div className="sub-hd">
                                廠外水質警報 (即時)
                            </div>
                            <div className="warning-box">
                                <div className="warning-count">
                                    <img className="icon-warning" src="/assets/warning.png"/>
                                    <div className="title">當前警報</div>
                                    <div className="number">{alarmTotal}</div>
                                </div>

                                <div className="warning-list">
                                    {[...alarmList].map(item => {
                                        return (
                                            <div 
                                                className={`warning-item ${
                                                    item.rank === 'Emergency' ? 'warning-emergency' : 
                                                    item.rank === 'Dangerous' ? 'warning-danger' : 
                                                    item.rank === 'Alert' ? 'warning-alert' :
                                                    item.rank === 'Warning' ? 'warning-warning' :
                                                    'warning-default'
                                                }`} 
                                                key={item.id} 
                                                data-id={item.id}
                                            >
                                                {/* 修正 ESLint onClick 綁定寫法 */}
                                                <div className="warning-close" onClick={() => clearAlarm(item.id)}>×</div>
                                                <div className="warning-content">
                                                    <div>地點：{item.log_id}</div>
                                                    <div>開始時間：{dayjs(item.start).format('YYYY-MM-DD HH:mm:ss')}</div>
                                                    <div>警報設定值：{item.rank} / {
                                                        item.log_id === "柴頭港溪截流站-閘門口" 
                                                            ? item.set_value
                                                            : parseFloat(item.set_value).toFixed(1)
                                                    }</div>
                                                    <div>警報訊息：{item.log_id === "柴頭港溪截流站-閘門口" 
                                                        ? `${(item.alarm_value * 100).toFixed(0)}%` 
                                                        : item.alarm_value.toFixed(1)}
                                                    ，{translateAlarmMessage(item.message)}</div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>

                        {/* ② 廠外進流水質預測 (1小時後) */}
                        <div className="sub-section section-2">
                            <div className="sub-hd">
                                廠外進流水質預測 (1小時後)
                            </div>
                            <div className="predicted-conductivity-single">
                                導電度 <span className="highlight-value">{predictedConductivity.toFixed(1)}</span> <span className="highlight-unit">(µs/cm)</span>
                            </div>
                            <div
                                aria-hidden="true"
                                style={{
                                    width: '82%',
                                    height: '1px',
                                    margin: '10px auto',
                                    backgroundColor: 'rgba(255, 255, 255, 0.25)'
                                }}
                            />
                            <div className="predicted-conductivity-single">
                                24小時 COD 平均濃度<br/>
                                <span className="highlight-value">{codAverage24h.toFixed(1)}</span> <span className="highlight-unit">(mg/L)</span>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;
